<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
				<span class="topTitle">配置指令内容</span>
			</div>
			<el-form ref="addBody" :rules="rules" :model="addBody" label-position='top'>
				<el-form-item label="插入组件" :label-width="formLabelWidth">
					<el-radio-group v-model="radio">
						<el-radio :label="3">单行文本</el-radio>
						<el-radio :label="6">多行文本</el-radio>
						<el-radio :label="9">单选框</el-radio>
						<el-radio :label="12">多选框</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="" prop="desc" :label-width="formLabelWidth">
					<el-input v-model="addBody.desc" placeholder="请输入内容" type="textarea" style="width: 432px;"
						rows='5'></el-input>

					<div style="color: #6B7280;">请在文本框内编辑指令，选中文本 > 插入组件，让AI应用内容更加丰富</div>
				</el-form-item>



				<div class="dialog-footer">
					<el-button @click="goBack">上一步</el-button>
					<el-button type="primary" @click="editUser('addBody')">创建</el-button>
				</div>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import ImageUpload from "@/components/ImageUpload"
	export default {
		components: {
			ImageUpload
		},
		data() {
			return {
				radio: 3,
				formLabelWidth: '120px',
				addBody: {
					area_name: '',
					mobile: '',
					uuid: '',
					role_uuid: '',
					desc: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					area_name: [{
						required: true,
						message: '请输入视频标题',
						trigger: 'blur'
					}, ],
					mobile: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, ]
				},
				lmList: [{
						id: 1,
						name: '研发灵感'
					},
					{
						id: 2,
						name: '产品灵感'
					},
					{
						id: 3,
						name: '营销灵感'
					}
				]
			}
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						// if (this.isEdit) {
						// 	this.network().updateRoleEmployee()
						// } else {
						// 	this.network().regionsave()
						// }
						
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					regionsave: async () => {
						const {
							status,
							data
						} = await regionsave({
							area_name: this.addBody.area_name,
							parent_id: 0,
							level: 1
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateRoleEmployee: async () => {
						const {
							status
						} = await updateRoleEmployee({
							name: this.addBody.name,
							mobile: this.addBody.mobile,
							uuid: this.addBody.uuid,
							avatar: this.images[0]
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					EmployeeDetail: async (uuid) => {
						const {
							data,
							status
						} = await EmployeeDetail(uuid)
						if (status !== 200) return
						this.addBody = data.result
						if (data.result.avatar != null) {
							this.images.push(data.result.avatar)
						}
					},
				}
			},
		},
	}
</script>

<style>
	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}
</style>